import { styled } from '@abyss/web/tools/styled';
import { Link } from '@abyss/web/ui/Link';
import { PageHeaderPrimitives } from '@abyss/web/ui/PageHeader';
import { NavMenuPrimitives } from '@abyss/web/ui/NavMenu';

//Note: Important is strongly discouraged, but required in some places to overcome the default abyss styles

export const HeaderFlexContainer = styled('div', {
  width: '1200px',
  margin: '0px 24px 0px 24px',

  '@screen < $sm': {
    margin: '0px 16px 0px 16px',
  },
});

export const NavigationFlexContainer = styled(HeaderFlexContainer, {
  display: 'flex',

  '@screen < $sm': {
    display: 'block',
  },
});

export const LanguageSelectorNavMenuRoot = styled(NavMenuPrimitives.Root, {
  backgroundColor: '$gray1 !important',
  justifyContent: 'flex-end !important',

  nav: {
    backgroundColor: '$gray1',
    minHeight: '34px',
  },

  [`@media print`]: {
    display: 'none',
  },
});

export const LanguageSelectorNavMenuItem = styled(NavMenuPrimitives.Item, {
  marginRight: '84px',
  marginTop: '$core.spacing.100', //8px
  marginBottom: '$core.spacing.100',
  '@screen < $sm': {
    marginRight: '52px',
  },
  '&.abyss-nav-menu-menu': {
    marginTop: 0,
    marginBottom: 0,
  },
});

export const LanguageSelectorButton = styled(NavMenuPrimitives.Trigger, {
  minHeight: 0,
  fontWeight: 500,
  lineHeight: '16px',
  fontSize: '12.64px',
  gap: '0',
  paddingTop: '8px',
  paddingBottom: '8px',
  div: {
    padding: '0px 0px 0px 4px',
    height: '16px',
  },
  span: {
    padding: 0,
  },
});

export const LanguageSelectorItem = styled(NavMenuPrimitives.MenuItem, {
  justifyContent: 'center',
  backgroundColor: '$gray2',
  borderRadius: 0,
});

export const MainNavRoot = styled(NavMenuPrimitives.Root, {
  display: 'flex',
  justifyContent: 'center !important',

  [`@media print`]: {
    display: 'none',
  },
});

export const MainNavItemList = styled(NavMenuPrimitives.List, {
  justifyContent: 'start',
});

export const MainNavLinkItem = styled(NavMenuPrimitives.Item, {
  backgroundColor: '$primary1',
  display: 'flex',
  justifyContent: 'center',
  minWidth: '214px',
  '@screen < $sm': {
    minWidth: '0px',
    flexGrow: '1',
    flexShrink: '1',
  },
  a: {
    minHeight: '56px',
  },
  'a:hover': {
    backgroundColor: '$interactive1',
    color: '$white',
  },
  '&:hover': {
    backgroundColor: '$interactive1',
  },
  variants: {
    isActive: {
      true: {
        backgroundColor: '$interactive1',
      },
    },
  },
});

export const LogoBar = styled('div', {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  minHeight: '96px',

  [`@media print`]: {
    display: 'none',
  },
});

export const LogoLink = styled(Link, {
  display: 'block',
  width: 'fit-content',
});

export const LogoBrandmark = styled(PageHeaderPrimitives.Brandmark, {
  '.abyss-brandmark': {
    // This class is only applied for the default UHC logo
    maxWidth: '155px',
  },
});
